import { inject, Injectable } from '@angular/core';
import { BrandingManagerService } from '@rx-applications/shared/branding/data-access';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  readonly #brandingManager = inject(BrandingManagerService);

  setTheme(theme: string = null ) {
    document.body.setAttribute('data-theme', theme || this.#brandingManager.getBrandAccess().getTheme());
  }
}
